import { ConfigFn } from '@config/types'

const config = (({ staticAssetPageUrl, staticPageUrlSuffix, publication }) => {
  const isRomandie = publication === 'romandie'
  return {
    widgetUrl: `${staticAssetPageUrl}/usersnap${staticPageUrlSuffix}`,
    cuiAnswerWidgetKey: '61f70378-8237-4a4d-a51c-2e4cf3c7bcac',
    articleSummaryWidgetKey: isRomandie
      ? '8dfc82b7-018a-4cea-8fa3-feda049ae2ab'
      : 'ac1e3e94-88d6-48fc-bf04-a9b4df8d7301',
    rateLimitLocalStorageKey: 'usersnapFeedbackCount',
    rateLimitPerMinute: 10,
  } as const
}) satisfies ConfigFn

export default config
